import type { FC } from 'react';
import { usePublicMarketAreas } from 'src/apis/storage/use-public-market-areas';
import { usePublicStorageLocations } from 'src/apis/storage/use-public-storage-locations';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { StorageLocationCreateForm } from 'src/pages/storage/locations-new/create/location-create-form';
import { storageLocationsEmptyParams } from 'src/pages/storage/locations-new/utils';

type Props = {
  storageServiceRoot: Successful<StorageServiceRootRequest>;
};

export const StorageLocationCreate: FC<Props> = ({ storageServiceRoot }) => {
  const storageLocations = usePublicStorageLocations({
    storageServiceRoot,
    params: storageLocationsEmptyParams,
  });

  const marketAreas = usePublicMarketAreas({
    storageServiceRoot,
  });

  if (!storageLocations.response || !marketAreas.response) {
    return <PageSpinner />;
  }

  return (
    <StorageLocationCreateForm
      storageLocations={storageLocations}
      marketAreas={marketAreas}
    />
  );
};
